<template>
  <div class="execute-box">
    <div class="total-box">
      <div class="title">项目合计</div>
      <div class="items">
        <div class="fee">
          <div class="fee-value">{{(detail.totalCost/100).toLocaleString()}}</div>
          <div class="fee-name">收入总计</div>
        </div>
        <div class="fee">
          <div class="fee-value">{{(total).toLocaleString()}}</div>
          <div class="fee-name">支出总计</div>
        </div>
        <div class="fee">
          <div class="fee-value">{{rate}}</div>
          <div class="fee-name">利润率</div>
        </div>
      </div>
    </div>
    <el-card class="member" header='添加成员'>
      <div class="master">
        <div class="title">培训专家：</div>
        <div class="list">
          <el-tag size="mini" :key="index" v-for="(master,index) in masters" :closable='!disabled' :disable-transitions="false" @close="handleClose(master)">
            {{master.memberName}}
          </el-tag>

          <el-button v-if="!disabled" class="button-new-tag" @click="openDialog('专家')">+</el-button>
          <el-button v-if="!disabled" icon="el-icon-upload2" size="mini" class="import" @click="importMember(1)">导入</el-button>

        </div>
      </div>
      <div class="master student">
        <div class="title" v-html="'学\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0员：'"></div>
        <div class="list">
          <el-tag size="mini" :key="index" v-for="(students,index) in students" :closable='!disabled' :disable-transitions="false" @close="handleClose(students)">
            {{students.memberName}}
          </el-tag>

          <el-button v-if="!disabled" class="button-new-tag" size="mini" @click="openDialog('学员')">+</el-button>
          <el-button v-if="!disabled" icon="el-icon-upload2" size="mini" class="import" @click="importMember(2)">导入</el-button>

        </div>
      </div>
    </el-card>
    <el-card class="file-box" header='相关文件'>
      <div class="tip">上传相关文件</div>
      <el-upload class="upload-demo" drag action="/api/file/upload" :on-error="onError" :before-upload="beforeUpload" :show-file-list="false" name="files" :data='{"type":"project"}' multiple :on-success="handleSuccess">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <div class="el-upload__tip"><span>支持扩展名: .rar .zip .doc .docx .xls .jpg…</span>
        <el-input placeholder="搜索相关文件" v-model="fileName" size="small" clearable>
          <el-button slot="append" @click="searchFile">搜索</el-button>
        </el-input>
      </div>
      <div class="file-list">
        <div class="file" v-for="(file,index) in fileList " :key="index" v-show="file.fileName.includes(fileName)">
          <div class="file-left" @click="handlePreview(file)">

            <img v-if="file.suffName.indexOf('xls')>-1" src="../../assets/img/xls.png" alt="" srcset="">
            <img v-else-if="file.suffName.indexOf('ppt')>-1" src="../../assets/img/ppt.png" alt="" srcset="">
            <img v-else-if="imgs.includes(file.suffName)" src="../../assets/img/jpg.png" alt="" srcset="">
            <img v-else-if="file.suffName.indexOf('pdf')>-1" src="../../assets/img/pdf.png" alt="" srcset="">
            <img v-else-if="['rar','zip'].includes(file.suffName)" src="../../assets/img/zip.png" alt="" srcset="">
            <img v-else src="../../assets/img/doc.png" alt="" srcset="">
            <span class="file-name">{{file.fileName}}</span>
          </div>
          <div class="tags">
            <el-tag v-if="file.tag" size="small" type='danger' effect="dark" closable :disable-transitions="false" @close="removeTag(file)">
              {{file.tag}}
            </el-tag>
            <el-input class="input-new-tag" v-if="fileId == file.uuid&&!file.tag" v-model="tagName" :ref="'saveTagInput'+file.uuid" size="mini" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
            </el-input>
            <el-button v-if="fileId != file.uuid &&!file.tag" class="button-new-tag" type="primary" plain size="mini" @click="showInput(file.uuid)">+添加标签</el-button>
          </div>
          <i class='el-icon-close' @click="removeFile(file)"></i>
        </div>
      </div>
    </el-card>

    <select-user @getResult="getSearchResult" :tags="masters" ref="selectUser" @close='selectShow = false' :title="'添加'+fieldName" :field='fieldName' :show='selectShow'></select-user>
    <preview-box ref="preview"></preview-box>
    <member-import ref="memberImport" @close='importClose' :is-project-import="true" :title="importTitle" :show='importShow' :demo-name="demoName"></member-import>

  </div>
</template>

<script>
import * as enumApi from '../../api/enumAPI'
import * as projectApi from '../../api/projectAPI'
import * as fileApi from '../../api/fileAPI'
import selectUser from './select_user.vue'
import preview from './preview.vue'
import memberImport from '../subcomponents/member_import.vue'

export default {
  name: 'execute',
  components: {
    'preview-box': preview,
    'select-user': selectUser,
    memberImport
  },
  props: {
    project: {
      type: Object,
      default: function () {
        return {}
      }
    },
    detail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fileList: [],
      feeList: [],
      addForm: {
        itemNames: []
      },
      fileName: "",
      formRules: {
        // itemNames: [{ required: true, message: "请选择费用项", trigger: "change", },],
        count: [{ type: 'number', message: '数量必须为数字值' }],
        price: [{ type: 'number', message: '单价必须为数字值' }],
        days: [{ type: 'number', message: '天数必须为数字值' }],
        fee: [{ required: true, type: 'number', message: '金额必须为数字值' }],
      },
      addDialogVisible: false,
      model: 'add',
      projectId: '',
      enumList: [],
      imgs: ['jpg', 'jpeg', 'png', 'gif', 'bmp'],
      fileId: '',
      tagName: '',
      masters: [],
      students: [],
      selectShow: false,
      fieldName: '专家',
      importShow: false,
      importTitle: '专家信息导入',
      demoName: ''

    };
  },
  computed: {
    total() {
      return this.feeList.reduce((pre, curr) => pre + (curr.fee || 0), 0) / 100
    },
    rate() {
      return ((this.detail.totalCost / 100 - this.total) / (this.detail.totalCost / 100) * 100).toFixed(2) + "%"
    },



  },
  watch: {

  },
  async created() {
    let res = await enumApi.list({ type: 'fee-item' })
    if (res.flag) {
      this.enumList = Array.from(res.data)
      console.log(res.data)

    }
  },
  async mounted() {
    this.projectId = this.$route.params.id
    let res = await projectApi.qryProjectFile(this.projectId, 1)
    if (res.flag) {
      this.fileList = res.data
    }
    await this.qryFeeList()
    await this.qryMemberList()
  },
  methods: {
    async qryFeeList() {
      let res = await projectApi.qryProjectFee(this.projectId)
      if (res.flag) {
        this.feeList = res.data
      }
    },
    async qryMemberList() {
      let res = await projectApi.qryProjectMember({ projectId: this.projectId })
      if (res.flag) {
        this.students = res.data.filter(m => m.memberType == 0)
        this.masters = res.data.filter(m => m.memberType == 1)
      }
    },




    async validate() {
      let flag = true
      await this.$refs.addFormRef.validate(async (valid, rules) => {
        if (!valid) {
          for (const key in rules) {
            flag = false;
            console.log(key, rules[key][0].message)
            this.$message.error(rules[key][0].message)
            throw Error(rules[key][0].message)
          }
          return
        }
      })
      if (!flag) {
        throw Error('校验失败')
      }
    },
    removeById(id) {
      this.feeList = this.feeList.filter(f => f.itemId != id)
    },
    handleClose(item) {
      console.log("handleClose", item);
      if (item.memberType == 1) {
        this.masters = this.masters.filter(m => m.memberName != item.memberName)
      } else {
        this.students = this.students.filter(m => m.memberName != item.memberName)
      }
    },
    removeTag(file) {
      console.log("removeTag", file);
      file.tag = ''

    },
    openDialog(name) {
      if (this.fieldName != name) {
        this.fieldName = name
        this.$refs.selectUser.qryList()
      }
      if (this.fieldName == '专家') {
        this.$refs.selectUser.setTags(this.masters)
      } else {
        this.$refs.selectUser.setTags(this.students)
      }
      this.selectShow = true
    },

    showInput(id) {//点击添加标签按钮
      this.addTagsFlag = true;
      this.fileId = id
      this.$nextTick(_ => {
        console.log("showInput", this.$refs);
        this.$refs['saveTagInput' + id][0].$refs.input.focus();
      });
    },

    async handleInputConfirm() {
      console.log('handleInputConfirm');
      let tagName = this.tagName;
      if (tagName) {
        // this.fileList.find(f => f.id == this.fileId).tags.push(tagName)
        this.fileList.find(f => f.uuid == this.fileId).tag = tagName
        let file = this.fileList.find(f => f.uuid == this.fileId)
        await projectApi.saveFile(file)
      }
      this.fileId = ''
      this.addTagsFlag = false;
      this.tagName = '';
    },
    async getSearchResult(data) {
      console.log('getSearchResult', data);
      if (this.fieldName == '专家') {
        this.masters = [...data]
      } else {
        this.students = [...data]
      }
      this.$refs.selectUser.$refs.form.resetFields()
      this.selectShow = false

    },
    async handleSuccess(res, file, fileList) {
      this.loading.close()
      file.status = file.status
      let projectId = this.$route.params.id
      if (res.flag) {
        let uploadFile = { projectId, uuid: res.data[0], fileName: file.name, tag: '', suffName: file.name.substring(file.name.lastIndexOf('.') + 1), type: 1 }
        res = await projectApi.saveFile(uploadFile)
        if (res.flag) {
          this.$message.success('上传成功')
          this.fileList.push(uploadFile)
        }
      } else {
        this.$message.error(res.message)
      }
      console.log("handleSuccess", res);
    },
    async handlePreview(file) {
      let fileName = file.fileName
      let uuid = file.uuid
      let suffName = fileName.substring(fileName.lastIndexOf('.') + 1)
      console.log('预览pdf', fileName, suffName)
      let offices = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf']
      if (!offices.includes(suffName) && !this.imgs.includes(suffName) && 'txt' != suffName) {

        return
      }
      let res = await fileApi.preview({ uuid, suffName, fileName })
      console.log("handlePreview", suffName);
      if (offices.includes(suffName)) {
        let blob = new Blob([res], { type: 'application/pdf' })
        let href = URL.createObjectURL(blob)
        console.warn(href)
        this.$refs.preview.fileSrc = href
        // this.src = `./pdf/web/viewer.html?file=${encodeURIComponent(href)}`
        //window.open(`./pdf/web/viewer.html?file=${encodeURIComponent(href)}`);
        //this.src = this.getObjectURL(res)
        this.$refs.preview.fileVisible = true
      } else if (this.imgs.includes(suffName)) {
        let blob = new Blob([res])
        let href = URL.createObjectURL(blob)
        console.warn(href)
        this.$refs.preview.imgSrc = href
        this.$refs.preview.imgVisible = true
      } else if ('txt' == suffName) {
        console.log('txt', res);
        let blob = new Blob([res], { type: 'text/plain' })
        let href = URL.createObjectURL(blob)
        console.warn(href)
        this.$refs.preview.fileSrc = href
        this.$refs.preview.fileVisible = true

      }
    },
    onError(err, files, fileList) {
      console.log("onError", err);
      this.loading.close()
      this.$message.error(err);
    },
    beforeUpload(file) {
      this.loading = this.$loading({
        target: '.container',
        lock: true,
        text: '拼命加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.3)'
      });
    },
    searchFile() {

    },
    removeFile(file) {
      //if (this.disabled) return
      return this.$confirm(`确定移除 ${file.fileName}？`).then(() => {
        projectApi.delFile(file.uuid).then(res => {
          if (res.flag) {
            this.fileList = this.fileList.filter(f => f.uuid != file.uuid)
          }
        })
      })

    },
    importMember(type) {
      if (type == 1) {
        this.importTitle = '专家信息导入'
        this.demoName = 'master'
      } else {
        this.importTitle = '学员信息导入'
        this.demoName = 'student'
      }
      this.importShow = true
    },
    importClose(memberList) {
      console.log('importClose', memberList);
      if (memberList && memberList.length) {
        let list = memberList.map(m => {
          return { memberId: m.id, memberName: m.name, memberType: this.importTitle == '专家信息导入' ? '1' : '0', projectId: this.projectId }
        })

        if (this.importTitle == '专家信息导入') {
          let obj = {};
          this.masters = [...this.masters, ...list].reduce((cur, next) => {
            obj[next.memberId] ? "" : obj[next.memberId] = true && cur.push(next);
            return cur;
          }, [])
        } else {
          let obj = {};
          this.students = [...this.students, ...list].reduce((cur, next) => {
            obj[next.memberId] ? "" : obj[next.memberId] = true && cur.push(next);
            return cur;
          }, [])
        }
      }
      this.importShow = false
    },
    async saveFile(file) {
      let res = await projectApi.saveFile(file)
    }
  },
};
</script>

<style  lang="less">
.execute-box {
  .el-card {
    border: none;
    box-shadow: none;
    border-radius: 0;
    padding-bottom: 20px;
    .el-card__header {
      padding: 20px 0;
      margin: 0 40px;
      padding-left: 20px;
      position: relative;
      &::before {
        position: absolute;
        content: "";
        width: 4px;
        height: 20px;
        background: #346aff;
        opacity: 1;
        display: block;
        left: 0px;
        top: 20px;
      }
    }
    .el-card__body {
      padding: 0 40px;
      .el-table {
        font-size: 14px;
        .el-table__cell {
          padding: 5px 0;
        }
        th {
          color: #3c4353;
          background: #ebf0ff;
          // font-size: 15px;
          // font-weight: normal;
          border-color: #dee7ff;
        }
        tbody {
          font-size: 12px;
          button {
            margin-top: 0;
            font-size: 14px;
          }
          .item-name {
            .cell {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .el-icon-question {
                color: #dcdcdc;
              }
            }
          }
        }
      }
    }
    .remark-title {
      color: #3c4353;
      margin: 20px 0;
    }
  }
  .total-box {
    background: #f5f7ff;
    padding: 20px;
    margin: 20px 40px 0 40px;

    border: 1px solid #dee7ff;
    color: #3c4353;
    .title {
      font-size: 16px;
    }
    .items {
      display: flex;
      margin-top: 20px;
      .fee {
        flex: 1;
        padding: 20px 60px;
        background: #a3baf3;
        border-radius: 5px;
        .fee-value {
          font-size: 20px;
        }
        .fee-name {
          margin-top: 10px;
          font-size: 15px;
          opacity: 0.5;
        }
      }
      .fee + .fee {
        margin-left: 20px;
      }
      .fee:nth-child(2) {
        background: #f6e1e1;
      }
      .fee:nth-child(3) {
        background: #d6f3ef;
      }
    }
  }
  .el-dialog {
    .el-input__inner {
      min-width: 150px;
    }
  }

  .member {
    .title {
      font-size: 14px;
    }
    .master {
      margin: 20px 0;
      display: flex;
      align-items: center;
      .el-tag {
        color: #35ae7b;
        background: #d6f3ef;
        border: none;
        margin-right: 10px;
      }
      .list {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
      }
    }
    .student .el-tag {
      margin-right: 10px;
      margin-bottom: 10px;
    }
    .button-new-tag {
      margin-left: 10px;
      height: 20px;
      line-height: 20px;
      width: 20px;
      padding: 0;
    }
    .import {
      padding: 3px 10px;
    }
    .input-new-tag {
      width: 90px;
      margin-left: 10px;
      vertical-align: bottom;
    }
  }
  .file-box {
    .tip {
      color: #272a3b;
      font-size: 14px;
      padding: 10px 0;
    }
    .el-upload {
      width: 100%;
      .el-upload-dragger {
        width: 100%;
      }
    }
    .file-list {
      margin: 20px 0;
      padding: 20px;
      border: 1px solid #dfdfe1;
      border-radius: 5px;
      display: flex;
      flex-direction: column;

      .file {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        .file-left {
          cursor: pointer;
          display: flex;
          align-items: center;
          width: 240px;

          img {
            width: 20px;
          }
          .file-name {
            margin-left: 10px;
            font-size: 14px;
            color: #606266;
          }
        }

        i {
          font-size: 18px;
        }
        > .el-icon-close {
          cursor: pointer;
          color: #606266;
        }
        .el-icon-circle-check {
          color: #67c23a;
        }
      }
    }
    .el-upload__tip {
      display: flex;
      justify-content: space-between;
      > span {
        white-space: nowrap;
        color: #a6aab8;
      }
      .el-input {
        width: auto;
        .el-input__inner {
          border-color: #b6cce5;
          background: #ecf5ff;
          border-right: none;
        }
        input::-webkit-input-placeholder {
          color: #b6cce5;
        }
        .el-input-group__append {
          background: #3a62ff;
          color: #fff;
          border: 1px solid #3a62ff;
        }
      }
    }
  }
}
</style>
